module.exports = __webpack_public_path__ + "img/ricardo.6dbe1c9b.jpg";